import { render, staticRenderFns } from "./DoroButton.vue?vue&type=template&id=d8b83aa2&functional=true&"
import script from "./DoroButton.vue?vue&type=script&lang=ts&"
export * from "./DoroButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports